// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3UOu8","icon":"style_icon__2aagQ"};